/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerRightDown = createReactComponent(
  "corner-right-down",
  "IconCornerRightDown",
  [["path", { d: "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4", key: "svg-0" }]]
);

export { IconCornerRightDown as default };
//# sourceMappingURL=IconCornerRightDown.js.map
